import { render, staticRenderFns } from "./UploadFloorPlanTable.vue?vue&type=template&id=2f908c2e&"
import script from "./UploadFloorPlanTable.vue?vue&type=script&lang=js&"
export * from "./UploadFloorPlanTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadFloorPlanTable.vue?vue&type=style&index=0&id=2f908c2e&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd})
